/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';
import type { TrainingEmployeeViewFilter } from './TrainingEmployeeViewFilter';

export type TrainingEmployeeViewRequest = {
    trainingEmployeeFilter?: TrainingEmployeeViewFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: TrainingEmployeeViewRequest.exposeType;
}

export namespace TrainingEmployeeViewRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
